/**
 * Tencent is pleased to support the open source community by making outerdata-opensouce available.
 * Copyright (C) 2019 Limited, Tencent company. All rights reserved.
 * Licensed under the MIT License (the "License"); you may not use this file except in compliance
 * with the License. You may obtain a copy of the License at
 * http://opensource.org/licenses/MIT
 * Unless required by applicable law or agreed to in writing, software distributed under the License is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND,
 * either express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
// eslint-disable-next-line camelcase
import legendTw from '@/lang/tw/legend_tw.js'
export const legend = legendTw

export const common = {
    Domestic: '中國',
    Overseas: '全球',
    Non_Hubei: '湖北省外',
    Region: '地區',
    GRegion: '國家/地區',
    Macau: '澳門',

    Active_Cases: '現有確診',
    Suspected_Cases: '無症狀感染者',
    Severe_Cases: '現有重症',
    Imported_Cases: '境外輸入',
    New_Cases: '新增確診',
    Total_Cases: '累計確診',
    Total_Recovered: '累計治癒',
    Total_Deaths: '累計死亡',

    Data_Explanations: '數據說明',
    New: '最新',
    More: '更多',
    Show_Less: '收起',
    Close: '關閉',

    covidmap: 'COVID-19 地圖',
    coviddata: '全球疫情數據',
    China_Updates: '中國疫情數據',

    time: '更新時間',
    updating: '更新中'
}

export const home = {
    COVID_19_Map: '新型冠狀病毒感染的助燃疫情',
    Regional_Updates: '全球疫情',
    China_Updates: '中國疫情',
    Overseas_Updates: '全球疫情情況',
    Live_Updates: '動態播報',
    D_Live_Updates: '國內動態播報',
    O_Live_Updates: '海外動態播報'
}

export const details = {
    COVID_19_Live_Updates: '疫情實時數據',
    COVID_19_Map: '疫情地圖',
    Regional_Updates: '各地區疫情情況',
    End: '已加載完全部動態',
    title: '疫情數據說明',
    info_1: '數據來源：',
    info_2: '海外疫情數據均來自各國家和地區官方通報及媒體公開報道。',
    info_3: '數據更新時間：',
    info_4: '數據實時更新，因計算、核實需要，與官方發佈時間相比，將存在一定延遲。',
    info_5: '說明：',
    info_6: '因“鑽石公主號”郵輪內人員來自世界多國，故在郵輪上確診的病例數據計入日本，離開郵輪後確診的病例數據則分別計入其所在國。若出現其他特殊情況，將以各國家和地區官方通報的統計口徑為准。',
    info_7: '“現有確診數”為當前正在治療中的確診人數，此數值會隨疫情數據的實時更新而發生變化。',
    info_8: '現有確診數=累計確診數-累計死亡數-累計治癒數',
    info_9: '疫情信息數據只供參考'
}

export const url = {
    header_bg_logo: require('@/assets/images/bg.jpg'),
    header_bg_empty: require('@/assets/images/bg.jpg')
}

export const currentProvData = {
    Afghanistan: '阿富汗',
    Albania: '阿爾巴尼亞',
    Algeria: '阿爾及利亞',
    Andorra: '安道爾',
    Angola: '安哥拉',
    Antarctica: '南極洲',
    'Antigua and Barbuda': '安提瓜和巴布達',
    Argentina: '阿根廷',
    Armenia: '亞美尼亞',
    Australia: '澳大利亞',
    Austria: '奧地利',
    Azerbaijan: '阿塞拜疆',
    'The Bahamas': '巴哈馬',
    Bahrain: '巴林',
    Bangladesh: '孟加拉',
    Barbados: '巴巴多斯',
    Belarus: '白俄羅斯',
    Belgium: '比利時',
    Belize: '伯利茲',
    Benin: '貝寧',
    Bermuda: '百慕大',
    Bhutan: '不丹',
    Bolivia: '玻利維亞',
    'Bosnia and Herzegovina': '波黑',
    Botswana: '博茨瓦納',
    Brazil: '巴西',
    Brunei: '文萊',
    Bulgaria: '保加利亞',
    'Burkina Faso': '布基納法索',
    Burundi: '布隆迪',
    Cambodia: '柬埔寨',
    Cameroon: '喀麥隆',
    Canada: '加拿大',
    'Cape Verde': '佛得角',
    'Central African Republic': '中非共和國',
    Chad: '乍得',
    Chile: '智利',
    China: '中國',
    Colombia: '哥倫比亞',
    Comoros: '科摩羅',
    'Republic of the Congo': '剛果（布）',
    'Costa Rica': '哥斯達黎加',
    Croatia: '克羅地亞',
    Cuba: '古巴',
    Cyprus: '塞浦路斯',
    'Czech Republic': '捷克',
    Denmark: '丹麥',
    Djibouti: '吉布提',
    Dominica: '多米尼加',
    'Dominican Republic': '多明尼加共和國',
    Ecuador: '厄瓜多爾',
    Egypt: '埃及',
    'El Salvador': '薩爾瓦多',
    'Equatorial Guinea': '赤道幾內亞',
    Eritrea: '厄立特里亞',
    Estonia: '愛沙尼亞',
    Ethiopia: '埃塞俄比亞',
    'Falkland Islands': '福克蘭群島',
    'Faroe Islands': '法羅群島',
    Fiji: '斐濟',
    Finland: '芬蘭',
    France: '法國',
    'French Guiana': '法屬圭亞那',
    'French Southern and Antarctic Lands': '法屬南半球和南極領地',
    Gabon: '加蓬',
    Gambia: '岡比亞',
    'Gaza Strip': '加沙',
    Georgia: '格魯吉亞',
    Germany: '德國',
    Ghana: '加納',
    Greece: '希臘',
    Greenland: '格陵蘭',
    Grenada: '格林納達',
    Guadeloupe: '瓜德羅普',
    Guatemala: '危地馬拉',
    Guinea: '幾內亞',
    'Guinea Bissau': '幾內亞比紹',
    Guyana: '圭亞那',
    Haiti: '海地',
    Honduras: '洪都拉斯',
    'Hong Kong': '香港',
    Hungary: '匈牙利',
    Iceland: '冰島',
    India: '印度',
    Indonesia: '印度尼西亞',
    Iran: '伊朗',
    Iraq: '伊拉克',
    'Iraq-Saudi Arabia Neutral Zone': '伊拉克阿拉伯中立區',
    Ireland: '愛爾蘭',
    'Isle of Man': '馬恩島',
    Israel: '以色列',
    Italy: '意大利',
    'Ivory Coast': '科特迪瓦',
    Jamaica: '牙買加',
    'Jan Mayen': '揚馬延島',
    Japan: '日本',
    Jordan: '約旦',
    Kazakhstan: '哈薩克斯坦',
    Kenya: '肯尼亞',
    Kerguelen: '凱爾蓋朗群島',
    Kiribati: '基里巴斯',
    'North Korea': '朝鮮',
    'South Korea': '韓國',
    Kuwait: '科威特',
    Kyrgyzstan: '吉爾吉斯斯坦',
    Laos: '老撾',
    Latvia: '拉脫維亞',
    Lebanon: '黎巴嫩',
    Lesotho: '萊索托',
    Liberia: '利比里亞',
    Libya: '利比亞',
    Liechtenstein: '列支敦士登',
    Lithuania: '立陶宛',
    Luxembourg: '盧森堡',
    Macau: '澳門',
    Macedonia: '北馬其頓',
    Madagascar: '馬達加斯加',
    Malawi: '馬拉維',
    Malaysia: '馬來西亞',
    Maldives: '馬爾代夫',
    Mali: '馬里',
    Malta: '馬耳他',
    Martinique: '馬提尼克',
    Mauritania: '毛里塔尼亞',
    Mauritius: '毛里求斯',
    Mexico: '墨西哥',
    Moldova: '摩爾多瓦',
    Monaco: '摩納哥',
    Mongolia: '蒙古',
    Morocco: '摩洛哥',
    Mozambique: '莫桑比克',
    Myanmar: '緬甸',
    Namibia: '納米比亞',
    Nepal: '尼泊爾',
    Netherlands: '荷蘭',
    'New Caledonia': '新喀裡多尼亞',
    'New Zealand': '新西蘭',
    Nicaragua: '尼加拉瓜',
    Niger: '尼日爾',
    Nigeria: '尼日利亞',
    'Northern Mariana Islands': '北馬里亞納群島',
    Norway: '挪威',
    Oman: '阿曼',
    Pakistan: '巴基斯坦',
    Panama: '巴拿馬',
    'Papua New Guinea': '巴布亞新幾內亞',
    Paraguay: '巴拉圭',
    Peru: '秘魯',
    Philippines: '菲律賓',
    Poland: '波蘭',
    Portugal: '葡萄牙',
    'Puerto Rico': '波多黎各',
    Qatar: '卡塔爾',
    Reunion: '留尼旺島',
    Romania: '羅馬尼亞',
    Russia: '俄羅斯',
    Rwanda: '盧旺達',
    'San Marino': '聖馬力諾',
    'Sao Tome and Principe': '聖多美和普林西比',
    'Saudi Arabia': '沙特阿拉伯',
    Senegal: '塞內加爾',
    Seychelles: '塞舌爾',
    'Sierra Leone': '塞拉利昂',
    Singapore: '新加坡',
    Slovakia: '斯洛伐克',
    Slovenia: '斯洛文尼亞',
    'Solomon Islands': '所羅門群島',
    Somalia: '索馬里',
    'South Africa': '南非',
    Spain: '西班牙',
    'Sri Lanka': '斯里蘭卡',
    'St. Christopher-Nevis': '聖',
    'St. Lucia': '聖露西亞',
    'St. Vincent and the Grenadines': '聖文森特和格林納丁斯',
    Sudan: '蘇丹',
    Suriname: '蘇里南',
    Svalbard: '斯瓦爾巴特群島',
    Swaziland: '斯威士蘭',
    Sweden: '瑞典',
    Switzerland: '瑞士',
    Syria: '敘利亞',
    Taiwan: '台灣',
    Tajikistan: '塔吉克斯坦',
    'United Republic of Tanzania': '坦桑尼亞',
    Thailand: '泰國',
    Togo: '多哥',
    Tonga: '湯加',
    'Trinidad and Tobago': '特里尼達和多巴哥',
    Tunisia: '突尼斯',
    Turkey: '土耳其',
    Turkmenistan: '土庫曼斯坦',
    'Turks and Caicos Islands': '特克斯和凱科斯群島',
    Uganda: '烏干達',
    Ukraine: '烏克蘭',
    'United Arab Emirates': '阿拉伯聯合酋長國',
    'United Kingdom': '英國',
    'United States of America': '美國',
    Uruguay: '烏拉圭',
    Uzbekistan: '烏茲別克斯坦',
    Vanuatu: '瓦努阿圖',
    Venezuela: '委內瑞拉',
    Vatican: '梵蒂岡',
    Vietnam: '越南',
    'Western Sahara': '西撒哈拉',
    'Western Samoa': '西薩摩亞',
    Yemen: '也門',
    Yugoslavia: '南斯拉夫',
    'Democratic Republic of the Congo': '剛果（金）',
    Zambia: '贊比亞',
    Zimbabwe: '津巴布韋',
    'South Sudan': '南蘇丹',
    Somaliland: '索馬里蘭',
    Montenegro: '黑山',
    Kosovo: '科索沃',
    'Republic of Serbia': '塞爾維亞共和國'
}
